import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { fetchBillingHistory } from "../features/billingHistory/billingHistory.thunk";
import { TGetBillingHistoryPayload } from "../services/apiV2.types";

type TBillingHistoryParams = TGetBillingHistoryPayload;

export const useBillingHistory = ({
  perPage,
  lastInvoiceId,
}: TBillingHistoryParams) => {
  const { data, error, isLoading, hasMore, total } = useAppSelector(
    (state) => state.billingHistory,
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    const promise = dispatch(fetchBillingHistory({ perPage, lastInvoiceId }));
    return () => {
      promise.abort();
    };
  }, [dispatch, perPage, lastInvoiceId]);

  return { data, error, isLoading, hasMore, total };
};
